<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <!--<p>appquestion4</p>-->
        <p>The binary number<br> {{ answerTwoC.binary }} <br> converts to: <br><span class="largetext">{{ answerTwoC.answer }}</span></p>

      </div>
    </section>
</template>

<script>
export default {
  props: {
    answerTwoC: {
      type: Object
    }
  }
};
</script>

<style>

</style>
